<template>
  <div class="main-content">
    <el-row style="margin:5px 0">
      <el-button size="mini" class="btn" type="primary" @click="onSave" v-if="detailForm.status=='DRAFT'&&operationType!=='view'" v-acl="PROC_TPL_MANAGE_MAINTAIN">保存</el-button>
      <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-if="(detailForm.status=='DRAFT'||detailForm.status=='ACTIVE')&&operationType!=='view'" v-acl="PROC_TPL_MANAGE_MAINTAIN">提交</el-button>
      <el-button size="mini" class="btn" type="primary" @click="onCancel">取消</el-button>
    </el-row>
    <el-card class="gri-info-card" shadow="never">
      <div slot="header" class="clearfix">
        <div class="title">
          <span class="line"></span>
          <span>GRI基本信息</span>
        </div>
      </div>
      <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="模板编码" prop="templateCode">
              <el-input v-model="detailForm.templateCode" disabled placeholder="请输入模板编码" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模板名称" prop="templateName">
              <el-input v-model="detailForm.templateName" :disabled="operationType=='view'" clearable maxlength="50" placeholder="请输入模板名称" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="版本号" prop="templateVersion">
              <el-input v-model="detailForm.templateVersion" disabled placeholder="请输入版本号" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="主键配置" prop="keyConfig">
              <ic-select table="TT_PROC" field="TPL_KEY_CONFIG" clearable :disabled="operationType=='view'||detailForm.templateVersion==2" v-model="detailForm.keyConfig" style="width:100%"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="GRI编码" prop="griCode">
              <el-input v-model.trim="detailForm.griCode" clearable placeholder="请输入GRI编码" :disabled="operationType=='view'||detailForm.templateVersion==2" readonly @click="showGriCodeDialog" style="width:100%">
                <el-button slot="append" icon="el-icon-search" @click="showGriCodeDialog" v-if="operationType!=='view'&&detailForm.templateVersion!=2"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="GRI名称" prop="griName">
              <el-input v-model="detailForm.griName" maxlength="50" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Category1" prop="category1Name">
              <el-input v-model="detailForm.category1Name" disabled placeholder="请输入模板编码" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Category2" prop="category2Name">
              <el-input v-model="detailForm.category2Name" disabled placeholder="请输入模板编码" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Category3" prop="category3Name">
              <el-input v-model="detailForm.category3Name" disabled placeholder="请输入模板编码" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型" prop="templateType">
              <ic-select table="TT_PROC_TEMPLATE" field="TPLTYPE" clearable :disabled="operationType=='view'||detailForm.templateVersion==2" v-model="detailForm.templateType" @change="onChangeTemplateType" style="width:100%"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生成品评报告" prop="generateSensoryReport">
              <ic-select table="COMMON" field="YES_NO_BOOLEAN" clearable :disabled="operationType=='view'||detailForm.templateType!='S'" v-model="detailForm.generateSensoryReport" style="width:100%"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="status">
              <ic-select v-model="detailForm.status" table="TT_PROC_TEMPLATE" field="STATUS" disabled placeholder="请选择" style="width:100%"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="描述" prop="comments">
              <el-input type="textarea" maxlength="100" autosize v-model="detailForm.comments" :disabled="operationType=='view'" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </el-card>
    <el-card class="process-config-card" shadow="never" :key="refreshKey">
      <div slot="header" class="clearfix">
        <div class="title">
          <span class="line"></span>
          <span>制成配置</span>
        </div>
        <div class="title_button">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="onAddProcess" v-if="operationType!=='view'" v-acl="PROC_TPL_MANAGE_MAINTAIN">添加制成</el-button>
          <el-button type="primary" size="mini" icon="el-icon-sort" @click="onSortProcess" :disabled="!detailForm.processes||detailForm.processes.length==0" v-acl="PROC_TPL_MANAGE_MAINTAIN">制成排序</el-button>
          <el-button type="primary" size="mini" icon="el-icon-setting" @click="onConfigSheet" :disabled="!detailForm.processes||detailForm.processes.length==0" v-acl="PROC_TPL_MANAGE_MAINTAIN">配置Excel模板</el-button>
        </div>
      </div>
      <div class="tabs-container" v-if="detailForm.processes.length>0">
        <el-tabs v-model="activeProcessTab" :closable="operationType!=='view'" type="border-card" @tab-remove="handleRemoveProcess" @tab-click="handleTabClick" class="process-tabs">
          <el-tab-pane v-for="(process, processIndex) in detailForm.processes" :key="process.tplProcessId" :label="process.processName" :name="processIndex.toString()">
            <div class="indicator_container" v-for="(indicator, indicatorIndex) in process.factors" :key="indicator.tplFactorId">
              <div class="indicator_item">
                <span>{{indicator.factorName}}</span>
                <span style="margin-left: 30px;font-weight:normal;font-size: 12px;text-decoration: underline;color: #f8ab01;">输入模式:{{indicator.inputModeText}}</span>
                <el-button style="position: absolute;right: 15px;" type="danger" size="mini" @click="deleteProcess(process.factors, indicatorIndex)" icon="el-icon-delete" v-if="operationType!=='view'" v-acl="PROC_TPL_MANAGE_MAINTAIN">删除</el-button>
              </div>
              <el-row style="margin-bottom: 10px;" v-if="indicator.inputMode=='TABLE'">
                <el-button type="primary" size="mini" icon="el-icon-view" @click="onView(process, indicator)">查看</el-button>
              </el-row>
              <el-tabs v-model="indicator.activeTab" type="border-card" @tab-click="handleIndicatorTabClick(process, indicator, $event)" class="indicator-tabs">
                <el-tab-pane label="参数列表" name="params">
                  <el-table :data="indicator.paramsLists" max-height="425" border stripe style="width: 100%">
                    <el-table-column prop="paramCode" label="参数编码" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="paramName" label="参数名称" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="dataType" label="数据类型" min-width="100">
                      <template slot-scope="scope">
                        <el-tag :color="setTagColor(scope.row.dataType)">
                          {{setDataType(scope.row.dataType)}}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column prop="uom" label="单位" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column label="控制维度绑定" min-width="100">
                      <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="onSetControl(process, indicator, scope.row, scope.$index)">设置</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column prop="required" label="必填" min-width="100">
                      <template slot-scope="scope">
                        <el-tag :type="scope.row.required ? 'success' : 'info'">
                          {{scope.row.required?'是':'否'}}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column prop="supplierViewable" label="供应商可见" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-switch v-model="scope.row.supplierViewable" active-color="#13ce66" inactive-color="#ff4949" :disabled="operationType=='view'"></el-switch>
                      </template>
                    </el-table-column>
                    <el-table-column prop="paramDesc" label="参数描述" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="standard" label="标准值" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="lineBreak" label="是否换行显示" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-switch v-model="scope.row.lineBreak" active-color="#13ce66" inactive-color="#ff4949" :disabled="operationType=='view'"></el-switch>
                      </template>
                    </el-table-column>
                    <el-table-column prop="category" label="所属分组" min-width="130">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.category" :disabled="operationType=='view'"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="290" fixed="right" v-if="operationType!=='view'">
                      <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleSetStandard(process, indicator,scope.row,'params',scope.$index)">设置标准</el-button>
                        <el-button type="primary" size="mini" @click="onSetRangeValue(process, indicator, scope.row, scope.$index)" v-if="operationType!=='view'">规格容差配置</el-button>
                        <el-button type="danger" size="mini" @click="deleteProcessParam(indicator, scope.row, scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="统计参数" name="statistics">
                  <el-row style="margin-bottom: 10px;" v-if="operationType!=='view'">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="onAddParam(process,indicator)">新增</el-button>
                  </el-row>
                  <el-table :data="indicator.statisticsParams" max-height="425" border stripe style="width: 100%">
                    <el-table-column prop="paramCode" label="参数编码" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="paramName" label="参数名称" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="dataType" label="数据类型" min-width="100">
                      <template slot-scope="scope">
                        <el-tag :color="setTagColor(scope.row.dataType)">
                          {{setDataType(scope.row.dataType)}}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column prop="uom" label="单位" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="supplierViewable" label="供应商可见" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{ scope.row.supplierViewable?'是':'否' }}
                        <!-- <el-switch v-model="scope.row.supplierViewable" active-color="#13ce66" inactive-color="#ff4949" :disabled="operationType=='view'"></el-switch> -->
                      </template>
                    </el-table-column>
                    <el-table-column prop="paramDesc" label="参数描述" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="statsType" label="统计类型" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">{{ scope.row.statsType | ic("TT_PROC", "STATISTIC_TYPE") }}</template>
                    </el-table-column>
                    <el-table-column prop="standard" label="标准值" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="lineBreak" label="是否换行显示" min-width="150" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{ scope.row.lineBreak?'是':'否' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="category" label="所属分组" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="250">
                      <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="onEdit(process,indicator,scope.row,scope.$index)" v-if="operationType!=='view'">编辑</el-button>
                        <el-button type="primary" size="mini" @click="onViewS(process,indicator,scope.row,scope.$index)" v-if="operationType=='view'">查看</el-button>
                        <el-button type="primary" size="mini" @click="onSetStandard(process, indicator,scope.row,'statistics',scope.$index)" v-if="operationType!=='view'">设置标准</el-button>
                        <el-button type="primary" size="mini" @click="onDel(process, indicator,scope.row,scope.$index)" v-if="operationType!=='view'">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="参数排序" name="sort">
                  <el-table :data="indicator.sortData" border row-key="id" :key="indicator.tplFactorId + refreshKey" :ref="`sortableTable_${indicator.tplFactorId}`" style="width: 100%;">
                    <el-table-column label="序号" prop="sortIndex" width="80"></el-table-column>
                    <el-table-column label="拖拽排序" width="80" align="center" v-if="operationType!=='view'">
                      <template slot-scope="scope">
                        <i class="fas fa-grip-vertical drag-handle el-icon-rank"></i>
                      </template>
                    </el-table-column>
                    <el-table-column prop="code" label="参数编码"></el-table-column>
                    <el-table-column prop="name" label="参数名称"></el-table-column>
                    <el-table-column prop="paramTypeText" label="参数类型"></el-table-column>
                    <el-table-column label="操作" width="180" align="center" v-if="operationType!=='view'">
                      <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-top" size="mini" @click="moveUp(scope.$index)" :disabled="scope.$index === 0">升序</el-button>
                        <el-button type="primary" icon="el-icon-bottom" size="mini" @click="moveDown(scope.$index)" :disabled="scope.$index === indicator.sortData.length - 1">降序</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
              <el-divider></el-divider>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <el-backtop target=".content" :bottom="100" :visibility-height="100" :right="20">
      <div :style="{height: '100%',width: '100%',backgroundColor: 'transparent',textAlign: 'center',lineHeight: '40px',color: '#1989fa',}">
        <img src="@/assets/img/backTop.svg" alt="" style="max-width:100%;max-height:100%;object-fit:contain">
      </div>
    </el-backtop>
    <el-dialog title="新增制成" :visible.sync="processDialogVisible" width="90%" :close-on-click-modal="false" @close="onCloseProcessDialog" class="process_dialog">
      <processDialog :processSelected="processSelected" :isDialog="true" @addProcess="addProcess" @onCancelProcess="onCloseProcessDialog"></processDialog>
    </el-dialog>
    <el-dialog title="参数标准值设置" :visible.sync="paramStandardVisible" width="30%" :close-on-click-modal="false" @close="onCloseParamStandardDialog" class="process_dialog">
      <paramStandardDialog :standardFormConfig="standardFormConfig" :currentStandardParamConfig="currentStandardParamConfig" @handleSaveStandardConfig="handleSaveStandardConfig" @onCloseParamStandardDialog="onCloseParamStandardDialog"></paramStandardDialog>
    </el-dialog>
    <!-- 多值维度查看 -->
    <el-dialog :title="multiTitle" :visible.sync="multiValuesDialogVisible" width="90%" :close-on-click-modal="false" @close="onCloseMultiValuesDialog" class="process_dialog">
      <previewDialog :previewMultiLists="previewMultiLists" :previewColumns="previewColumns"></previewDialog>
    </el-dialog>
    <el-dialog title="GRI" :visible.sync="griDialogVisible" width="90%" :close-on-click-modal="false" @close="onCloseGriDialog" class="process_dialog">
      <griDialog @onConfirmGri="onConfirmGri" @onCloseGri="onCloseGriDialog"></griDialog>
    </el-dialog>
    <!-- 新增/编辑统计参数 -->
    <el-dialog :title="title" :visible.sync="addStatisticsParamVisible" width="40%" @close="onCloseParamDialog" class="process_dialog">
      <statisticsConfig ref="statisticsConfig" :operationType="operationType" :paramNameLists="paramNameLists" :curForm="curForm" @handleSaveStatisticsConfig="handleSaveStatisticsConfig" @onCancelStatistics="onCloseParamDialog"></statisticsConfig>
    </el-dialog>
    <el-dialog title="制成排序" :visible.sync="sortDialogVisible" width="50%" :close-on-click-modal="false" @close="onCloseSortDialog" class="process_dialog">
      <sortDialog :isParamsDialog="isParamsDialog" :operationType="operationType" :sortData="sortLists" @setSort="setSort" @onCancelSort="onCloseSortDialog"></sortDialog>
    </el-dialog>
    <el-dialog title="导入Excel模板配置" :visible.sync="sheetDialogVisible" width="70%" :close-on-click-modal="false" @close="onCloseSheetDialog" class="process_dialog">
      <sheetDialog :sheetData="sheetData" :operationType="operationType" @setSheetSort="setSheetSort" @cancelSheetSort="onCloseSheetDialog"></sheetDialog>
    </el-dialog>
    <el-dialog title="配置控制维度" :visible.sync="controlDialogVisible" width="400px" :close-on-click-modal="false" class="process_dialog">
      <el-form :model="controlForm" ref="controlFormRef" label-position="top">
        <el-form-item label="请选择该参数控制的制成（可多选）：">
          <el-checkbox-group v-model="controlForm.dataList" :disabled="operationType=='view'">
            <el-checkbox v-for="item in controlProcessList" :key="item.processCode" :label="item.processCode">
              {{ item.processName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <el-row v-if="operationType!=='view'" style="margin-bottom: 15px;" type="flex" justify="center" align="middle">
        <el-button size="mini" @click="controlDialogVisible=false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirmControl">确定</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="规格容差配置规则" :visible.sync="rangeDialogVisible" width="400px" :close-on-click-modal="false" class="process_dialog">
      <el-form :model="rangeForm" ref="rangeFormRef">
        <el-form-item label="请选择类型：">
          <el-radio-group v-model="rangeForm.toleranceType">
            <el-radio :label="item.code" v-for="item in rangeValueDict">{{item.value}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="控制范围">
          <el-input style="width: 70%;" v-model="rangeForm.tolerance"></el-input>
        </el-form-item>
      </el-form>
      <el-row style="margin-bottom: 15px;" type="flex" justify="center" align="middle">
        <el-button size="mini" @click="rangeDialogVisible=false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirmRangeValue">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import processApi from "@/api/Process/index";
import { apiService } from "@/api/material/material-master-data";
import IcSelect from "@/components/common/icSelect";
import processDialog from "@/components/page/productManagement/ProcessBaseManagement.vue"
import paramStandardDialog from "./paramStandard.vue"
import previewDialog from "../../productManagement/previewDialog.vue";
import griDialog from "./griDialog.vue";
import statisticsConfig from "./StatisticsConfig.vue";
import sortDialog from "./sortDialog.vue";
import sheetDialog from './sheetDialog.vue'
import Sortable from 'sortablejs'
import commonFun from "@/utils/commonFun";
import {inputChoiceService} from "@/api/common/input-choice";
export default {
  name: "",
  components: {
    IcSelect,
    processDialog,
    paramStandardDialog,
    previewDialog,
    griDialog,
    statisticsConfig,
    sortDialog,
    sheetDialog
  },
  data() {
    return {
      tplId: "",
      detailForm: {
        templateCode: "",
        templateName: "",
        templateVersion: "",
        griCode: "",
        category1: "",
        category1Name: "",
        category2: "",
        category2Name: "",
        category3: "",
        category3Name: "",
        griName: "",
        templateType: "",
        templateTypeText: "",
        generateSensoryReport: null,
        status: "",
        statusText: "",
        comments: "",
        processes: [],
        griList: [],
      },
      rules: {
        templateName: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        keyConfig: [{required: true, message: "请选择主键配置", trigger: "change"}],
        griCode: [{ required: true, message: "请选择GRI编码", trigger: "change" }],
        templateType: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      activeProcessTab: "0",
      activeIndicatorTab: "",
      categoryList1: [],
      categoryList2: [],
      categoryList3: [],
      sortLists: [],
      processDialogVisible: false,
      paramStandardVisible: false,
      multiValuesDialogVisible: false,
      statisticsConfigVisible: false,
      addStatisticsParamVisible: false,
      griDialogVisible: false,
      sortDialogVisible: false,
      isParamsDialog: false,
      sheetDialogVisible: false,

      operationType: "",
      curForm: null,
      currentStandardParamConfig: {},
      standardFormConfig: {},
      refreshKey: 0,
      tplProcessId: "",
      processCode: "",
      factorCode: "",
      tplFactorId: "",
      curStandardType: "",
      curStandardIndex: "",
      sortableInstance: null, // 存储Sortable实例，用于销毁旧实例
      activeFactorId: null, // 记录当前激活的指标ID（用于排序时定位）
      paramOperationType: "",
      title: "新增统计参数",
      sheetData: [],
      processSelected: [],
      previewMultiLists: [],
      previewColumns: [],
      paramNameLists: [],
      staticIndex: "",
      multiTitle: '',

      controlDialogVisible: false,
      controlForm: {
        dataList: [],
      },
      rangeDialogVisible: false,
      rangeForm: {
        tolerance: "",
        toleranceType: ""
      },
      controlProcessList: [],
      rangeValueDict: [],
      selectedParam: null,
    }
  },
  watch: {
    refreshKey() {
      // 等待表格DOM更新完成后再初始化
      this.$nextTick(() => {
        this.initSortable();
      });
    }
  },
  computed: {

  },
  beforeDestroy() {
    // 组件销毁时清理实例
    if (this.sortableInstance) {
      this.sortableInstance.destroy()
    }
  },
  created() {
    this.operationType = this.$route.query.type
    if (this.$route.query.type == 'add') {
      this.detailForm.status = 'DRAFT'
      this.detailForm.templateVersion = 1
    } else {
      this.tplId = this.$route.query.tplId
      this.getDetailInfo(this.$route.query.tplId)
    }
    // let list = commonFun.listIC("TT_PROC", "TOLERANCE_TYPE");
    // this.rangeValueDict = Object.values(list).map(item => ({
    //   value: item.value,
    //   code: item.code
    // }));
    inputChoiceService.listInputChoice().then((res) => {
      let list = res.data.filter(ele => {
        return ele.fieldName === 'TOLERANCE_TYPE' && ele.tableName === 'TT_PROC'
      })
      this.rangeValueDict = list.map(item => ({
        value: item.chineseValue,
        code: item.code
      }))
      console.log("===============================")
      console.log(list)
    });
  },
  mounted() {
    // 数据初始化后重新创建拖拽实例
    this.$nextTick(() => {
      this.initSortable()
    })
  },
  methods: {
    getDetailInfo(tplId) {
      processApi.viewTemplate(tplId).then((res) => {
        console.log("🚀 ~ getDetailInfo ~ res:", res)
        if (res.code == '200') {
          this.detailForm = { ...res.data }
          if (this.detailForm.processes && this.detailForm.processes.length > 0) {
            this.detailForm.processes.forEach(process => {
              if (process.factors && process.factors.length > 0) {
                process.factors.forEach(item => {
                  item.activeTab = 'params'
                  item.statisticsParams = []
                  item.paramsLists = []
                  item.sortData = []
                  if (item.params && item.params.length > 0) {
                    item.params.forEach(param => {
                      if (param.paramType == 'STATISTIC') {
                        item.statisticsParams.push(param)
                      } else {
                        item.paramsLists.push(param)
                      }
                      // 构建排序数据，包含唯一标识用于后续同步
                      item.sortData.push({
                        id: param.id,  // 确保唯一
                        code: param.paramCode,
                        name: param.paramName,
                        type: param.paramType,
                        paramTypeText: param.paramTypeText,
                        sortIndex: param.sortIndex,
                        sourceIndex: item.params.indexOf(param) // 记录在原数组中的索引
                      })
                    })
                  }
                })
              }
            })
            this.controlProcessList = this.detailForm.processes.map(item => ({
              processCode: item.processCode,
              processName: item.processName,
            }))
          }
          console.log("🚀 ~ getDetailInfo ~ this.detailForm:", this.detailForm)
        }
      });
    },
    // Gri编码选择
    showGriCodeDialog() {
      this.griDialogVisible = true
    },
    // Gri编码选择
    onConfirmGri(data) {
      console.log("🚀 ~ onConfirmGri ~ data:", data)
      this.detailForm.griList = data.map(item => ({
        code: item.fiveBitCode,
        name: item.fiveBitCodeName
      }));
      this.detailForm.category1 = data[0].categoryLevel1Code;
      this.detailForm.category1Name = data[0].categoryLevel1Name;
      this.detailForm.category2 = data[0].categoryLevel2Code;
      this.detailForm.category2Name = data[0].categoryLevel2Name;
      this.detailForm.category3 = data[0].categoryLevel3Code;
      this.detailForm.category3Name = data[0].categoryLevel3Name;
      this.detailForm.griCode = data.map(o => o.fiveBitCode).toString();
      this.detailForm.griName = data.map(o => o.fiveBitCodeName).toString();
      this.griDialogVisible = false
    },
    // 关闭GRI弹窗
    onCloseGriDialog() {
      this.griDialogVisible = false
    },
    // 更改模板类型 
    onChangeTemplateType() {
      if(this.detailForm.templateType != 'S') {
        this.detailForm.generateSensoryReport = null;
      }
    },
    // 添加制成
    onAddProcess() {
      if (this.detailForm.processes && this.detailForm.processes.length > 0) {
        this.processSelected = this.detailForm.processes.map(ele => ele.processCode)
      }
      console.log("🚀 ~ onAddProcess ~ this.processSelected:", this.processSelected)
      this.processDialogVisible = true
    },
    // 添加制成
    addProcess(data) {
      console.log("🚀 ~ addProcess ~ data:", data)
      this.detailForm.processes = this.detailForm.processes.concat(data)
      // 更新排序索引
      this.detailForm.processes.forEach((item, index) => {
        item.sortIndex = index + 1;
      });
      console.log("🚀 ~ addProcess ~ this.detailForm.processes :", this.detailForm.processes)
      if (this.detailForm.processes && this.detailForm.processes.length > 0) {
        this.detailForm.processes.forEach(factor => {
          if (factor.factors && factor.factors.length > 0) {
            factor.factors.forEach(item => {
              item.activeTab = 'params'
              item.statisticsParams = []
              item.paramsLists = []
              item.sortData = []
              if (item.params && item.params.length > 0) {
                item.params.forEach(param => {
                  if (param.paramType == 'STATISTIC') {
                    item.statisticsParams.push(param)
                  } else {
                    item.paramsLists.push(param)
                  }
                  item.sortData.push({
                    id: param.id || `${param.paramCode}_${Date.now()}`,
                    code: param.paramCode,
                    name: param.paramName,
                    type: param.paramType,
                    paramTypeText: param.paramTypeText,
                    sortIndex: param.sortIndex,
                    sourceIndex: item.params.indexOf(param)
                  })
                })
              }
            })
          }
        })
      }
      this.controlProcessList = this.detailForm.processes.map(item => ({
        processCode: item.processCode,
        processName: item.processName,
      }))
      console.log(this.controlProcessList)
      this.processDialogVisible = false
    },
    onCloseProcessDialog() {
      this.processDialogVisible = false
    },
    // 制成排序
    onSortProcess() {
      this.sortLists = []
      if (this.detailForm.processes.length > 0) {
        this.detailForm.processes.forEach(ele => {
          this.sortLists.push({
            code: ele.processCode,
            name: ele.processName,
            sortIndex: ele.sortIndex,
          })
          this.sortDialogVisible = true
          this.isParamsDialog = true
        })
      }
    },
    // 制成排序保存
    setSort(data) {
      console.log("🚀 ~ setSort ~ data:", data)
      // 1. 根据排序后的数据重新排列detailForm.processes
      // data中包含排序后的processCode和对应的排序信息，通过processCode匹配原process对象
      this.detailForm.processes = data.map(sortedItem => {
        // 找到原processes中对应processCode的项
        return this.detailForm.processes.find(process =>
          process.processCode === sortedItem.code
        );
      }).filter(Boolean); // 过滤可能的匹配失败项（保险处理）
      // 2. 更新激活的tab为排序后的第一个，避免排序后激活状态异常
      this.detailForm.processes.forEach((item, i) => {
        item.sortIndex = i + 1;
      });
      this.activeProcessTab = "0";
      // 3. 触发组件重新渲染（可选，确保视图同步）
      this.refreshKey += 1;
      console.log("🚀 ~ setSort ~ 已更新制成顺序:", this.detailForm.processes);
      this.onCloseSortDialog()
    },
    // 关闭排序
    onCloseSortDialog() {
      this.sortLists = []
      this.sortDialogVisible = false
    },
    // 移除制成tab
    handleRemoveProcess(tab) {
      console.log("🚀 ~ handleRemoveProcess ~ tab:", tab)
      this.$confirm('是否确认移除当前制成?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detailForm.processes.splice(tab, 1)
        this.detailForm.processes.forEach(process => {
          if(process.factors&&process.factors.length > 0) {
            process.factors.forEach(factor => {
              if(factor.params&&factor.params.length > 0) {
                factor.params.forEach(param => {
                  if(param.processList&&param.processList.length > 0) {
                    let index = param.processList.findIndex(item => item.processCode === this.controlProcessList[tab].processCode);
                    param.processList.splice(index, 1);
                  }
                })
              }
            })
          }
        })
        this.controlProcessList.splice(tab, 1)
      })
    },
    // 点击制成tab
    handleTabClick(tab) {
      console.log("🚀 ~ handleTabClick ~ tab:", tab)
      this.activeProcessTab = tab.name
    },
    // 参数列表设置标准
    handleSetStandard(process, indicator, row, type, index) {
      this.tplProcessId = process.tplProcessId
      this.processCode = process.processCode
      this.factorCode = indicator.factorCode
      this.tplFactorId = indicator.tplFactorId
      this.curStandardType = type
      this.curStandardIndex = index
      this.standardFormConfig = {
        standardType: row.standardType ? row.standardType : 'NA',
        standard: row.standard,
      };
      this.currentStandardParamConfig = {
        paramName: row.paramName,
        dataType: row.dataType,
      }
      this.paramStandardVisible = true
    },
    // 标准值设置保存
    handleSaveStandardConfig(obj) {
      console.log("🚀 ~ handleSaveStandardConfig ~ obj:", obj)
      this.detailForm.processes.forEach(ele => {
        if (ele.tplProcessId == this.tplProcessId && ele.processCode == this.processCode) {
          if (!ele.factors || ele.factors.length == 0) {
            return
          }
          ele.factors.forEach(item => {
            console.log("🚀 ~ handleSaveStandardConfig ~ item:", item)
            if (item.tplFactorId == this.tplFactorId && item.factorCode == this.factorCode) {
              if (this.curStandardType == 'params') {
                this.$set(item.paramsLists[this.curStandardIndex], 'standardType', obj.standardType)
                this.$set(item.paramsLists[this.curStandardIndex], 'standard', obj.standard)
                item.paramsLists[this.curStandardIndex].standardType = obj.standardType
                item.paramsLists[this.curStandardIndex].standard = obj.standard
              } else {
                this.$set(item.statisticsParams[this.curStandardIndex], 'standardType', obj.standardType)
                this.$set(item.statisticsParams[this.curStandardIndex], 'standard', obj.standard)
                item.statisticsParams[this.curStandardIndex].standardType = obj.standardType
                item.statisticsParams[this.curStandardIndex].standard = obj.standard
              }
            }
          })
        }
      })
      console.log("🚀 ~ handleSaveStandardConfig ~ this.detailForm.processes:", this.detailForm.processes)
      this.onCloseParamStandardDialog()
    },
    onCloseParamStandardDialog() {
      this.tplProcessId = ''
      this.processCode = ''
      this.factorCode = ''
      this.tplFactorId = ''
      this.curStandardType = ''
      this.curStandardIndex = ''
      this.standardFormConfig = {};
      this.currentStandardParamConfig = {}
      this.paramStandardVisible = false
    },
    // 添加统计参数
    onAddParam(process, indicator) {
      this.addStatisticsParamVisible = true
      this.$nextTick(() => {
        console.log("🚀 ~ onAddParam ~ indicator:", indicator)
        console.log("🚀 ~ onAddParam ~ process:", process)
        this.tplProcessId = process.tplProcessId
        this.processCode = process.processCode
        this.factorCode = indicator.factorCode
        this.tplFactorId = indicator.tplFactorId
        //确保新增时参数名唯一
        this.paramNameLists = []
        this.detailForm.processes.forEach(ele => {
          if (ele.processCode == process.processCode) {
            if (!ele.factors || ele.factors.length == 0) {
              return
            }
            ele.factors.forEach(item => {
              if (indicator.factorCode == item.factorCode) {
                console.log("🚀 ~ onAddParam ~ item:", item)
                if (item.statisticsParams && item.statisticsParams.length > 0) {
                  item.statisticsParams.forEach(param => {
                    this.paramNameLists.push(param.paramName)
                  })
                }
                if (item.paramsLists && item.paramsLists.length > 0) {
                  item.paramsLists.forEach(param => {
                    this.paramNameLists.push(param.paramName)
                  })
                }
              }
            })
          }
        })
        console.log("🚀 ~ onAddParam ~ this.paramNameLists:", this.paramNameLists)
        this.paramOperationType = 'add'
        this.title = '新增统计参数'
        this.$refs.statisticsConfig.$refs['configForm'].resetFields()
        this.curForm = null
      });
    },
    // 添加统计参数保存
    handleSaveStatisticsConfig(obj) {
      console.log("🚀 ~ handleSaveStatisticsConfig ~ obj:", obj)
      console.log("🚀 ~ handleSaveStatisticsConfig ~ this.tplFactorId:", this.tplFactorId)
      console.log("🚀 ~ handleSaveStatisticsConfig ~ this.factorCode:", this.factorCode)
      this.detailForm.processes.forEach(ele => {
        // 首先找到是哪个制成
        if (ele.tplProcessId == this.tplProcessId && ele.processCode == this.processCode) {
          if (!ele.factors || ele.factors.length == 0) {
            return
          }
          ele.factors.forEach(item => {
            if (item.tplFactorId === this.tplFactorId && item.factorCode == this.factorCode) {
              if (this.paramOperationType == 'edit') {
                item.statisticsParams.splice(this.staticIndex, 1)
                item.statisticsParams.push(obj)
              } else {
                item.statisticsParams.push(obj)
              }
              item.statisticsParams.forEach((item, index) => {
                item.sortIndex = index + 1;
              });
              console.log("🚀 ~ handleSaveStatisticsConfig ~ item.statisticsParams:", item.statisticsParams)
              item.sortData.push({
                id: `${obj.paramCode}_${Date.now()}`,
                code: obj.paramCode,
                name: obj.paramName,
                type: obj.paramType,
                paramTypeText: obj.paramTypeText,
                sortIndex: item.sortData.length + 1,
              })
              // 更新排序索引
              item.sortData.forEach((item, index) => {
                item.sortIndex = index + 1;
              });

            }
          })
        }
      })
      this.onCloseParamDialog()
      this.refreshSortKey += 1;
    },
    // 编辑统计参数
    onEdit(process, indicator, row, index) {
      this.tplProcessId = process.tplProcessId
      this.processCode = process.processCode
      this.factorCode = indicator.factorCode
      this.tplFactorId = indicator.tplFactorId
      this.staticIndex = index
      this.curForm = JSON.stringify(row)
      this.paramOperationType = 'edit'
      this.title = '编辑统计参数'
      this.addStatisticsParamVisible = true
    },
    // 查看统计参数
    onViewS(process, indicator, row, index) {
      this.tplProcessId = process.tplProcessId
      this.processCode = process.processCode
      this.factorCode = indicator.factorCode
      this.tplFactorId = indicator.tplFactorId
      this.staticIndex = index
      this.curForm = JSON.stringify(row)
      this.paramOperationType = 'view'
      this.title = '查看统计参数'
      this.addStatisticsParamVisible = true
    },
    // 关闭统计参数弹窗
    onCloseParamDialog() {
      this.tplProcessId = ''
      this.processCode = ''
      this.factorCode = ''
      this.tplFactorId = ''
      this.paramOperationType = ''
      this.title = ''
      this.curForm = null
      this.addStatisticsParamVisible = false
      this.paramNameLists = []
    },
    // 统计参数设置标准
    onSetStandard(process, indicator, row, type, index) {
      this.tplProcessId = process.tplProcessId
      this.processCode = process.processCode
      this.factorCode = indicator.factorCode
      this.tplFactorId = indicator.tplFactorId
      this.curStandardType = type
      this.curStandardIndex = index
      this.standardFormConfig = {
        standardType: row.standardType ? row.standardType : 'NA',
        standard: row.standard,
      };
      this.currentStandardParamConfig = {
        paramName: row.paramName,
        dataType: row.dataType,
      }
      this.paramStandardVisible = true
    },
    onDel(process, indicator, row, index) {
      this.$confirm('是否确认删除此条数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detailForm.processes.forEach(ele => {
          if (ele.tplProcessId == process.tplProcessId && ele.processCode == process.processCode) {
            if (!ele.factors || ele.factors.length == 0) {
              return
            }
            ele.factors.forEach(item => {
              item.statisticsParams.splice(index, 1)
              item.statisticsParams.forEach((param, i) => {
                param.sortIndex = i + 1
              })
            })
          }
        })
      })
    },


    setTagColor(dataType) {
      const tagMap = {
        TEXT: "#909399",
        NUMBER: "#409EFF",
        SELECTOR: "#67C23A",
        DATE: "#E6A23C",
        BOOLEAN: "#F56C6C",
      }
      return tagMap[dataType] || "#E6A23C";
    },
    setDataType(dataType) {
      const tagMap = {
        TEXT: "文本型",
        NUMBER: "数字型",
        SELECTOR: "选择器",
        DATE: "日期型",
        BOOLEAN: "布尔型",
        DICT: "字典值"
      }
      return tagMap[dataType] || "";
    },
    handleIndicatorTabClick(process, indicator, tab) {
      console.log("🚀 ~ handleIndicatorTabClick ~ process:", process)
      console.log("🚀 ~ handleIndicatorTabClick ~ indicator:", indicator)
      console.log("🚀 ~ handleIndicatorTabClick ~ tab:", tab)
      indicator.activeTab = tab.name;
      if (tab.name == 'sort') {
        this.activeFactorId = indicator.tplFactorId; // 用tplFactorId作为唯一标识
        this.$nextTick(() => {
          this.initSortable();
        });
      } else {
        // 离开排序标签时清空
        this.activeFactorId = null;
      }
    },
    // 初始化拖拽排序
    initSortable() {
      // 先销毁已存在的实例，避免重复绑定
      if (this.sortableInstance) {
        this.sortableInstance.destroy()
      }
      // 获取当前激活的制成和指标
      const activeProcess = this.detailForm.processes[this.activeProcessTab];
      if (!activeProcess) return;
      console.log("🚀 ~ initSortable ~ activeProcess:", activeProcess)
      // 2. 通过记录的activeFactorId定位当前操作的指标（关键修改）
      const activeIndicator = activeProcess.factors.find(
        factor => factor.tplFactorId === this.activeFactorId
      );
      if (!activeIndicator) return;
      // 3. 获取当前指标的排序表格DOM（确保表格属于当前指标）
      // 注意：需要给每个指标的排序表格添加唯一标识，避免DOM选择错误
      const refKey = `sortableTable_${activeIndicator.tplFactorId}`;
      // 1. 从$refs中获取组件实例（可能是数组）
      const refElements = this.$refs[refKey];
      // 2. 如果是数组则取第一个元素（通常v-for生成的ref会是数组）
      const refElement = Array.isArray(refElements) ? refElements[0] : refElements;
      console.log("🚀 ~ initSortable ~ refElement:", refElement);
      // 3. 确保元素存在且包含$el属性
      if (!refElement || !refElement.$el) return;
      // 4. 获取表格tbody元素
      const table = refElement.$el.querySelector('.el-table__body-wrapper tbody');
      if (!table) return;
      this.sortableInstance = new Sortable(table, {
        handle: '.drag-handle', // 拖拽的手柄
        animation: 150, // 动画时间
        ghostClass: 'ghost',
        chosenClass: 'chosen',
        // 拖拽结束时触发
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt;
          // 移动当前指标的sortData
          const [movedItem] = activeIndicator.sortData.splice(oldIndex, 1);
          activeIndicator.sortData.splice(newIndex, 0, movedItem);
          // 更新排序序号
          activeIndicator.sortData.forEach((item, index) => {
            item.sortIndex = index + 1;
          });
          // 同步到原始参数列表（调用之前实现的同步方法）
          this.syncParamSortOrder(activeIndicator);
          // 刷新表格
          this.refreshKey += 1;
        }
      });
    },
    // 同步参数排序到原始列表
    syncParamSortOrder(indicator) {
      console.log("🚀 ~ syncParamSortOrder ~ indicator:", indicator)
      // 1. 构建排序映射：参数编码 -> 新排序索引
      const sortIndexMap = {};
      indicator.sortData.forEach((item, index) => {
        sortIndexMap[item.name] = index + 1; // 用paramCode作为唯一标识
      });
      console.log("🚀 ~ syncParamSortOrder ~ sortIndexMap:", sortIndexMap)

      // 2. 同步统计参数的排序索引
      indicator.statisticsParams.forEach(param => {
        if (sortIndexMap.hasOwnProperty(param.paramName)) {
          param.sortIndex = sortIndexMap[param.paramName];
        }
      });
      console.log("🚀 ~ syncParamSortOrder ~ indicator.statisticsParams:", indicator.statisticsParams)

      // 3. 同步普通参数的排序索引
      indicator.paramsLists.forEach(param => {
        if (sortIndexMap.hasOwnProperty(param.paramName)) {
          param.sortIndex = sortIndexMap[param.paramName];
        }
      });
      console.log("🚀 ~ syncParamSortOrder ~  indicator.paramsLists:", indicator.paramsLists)
      console.log('1312313213', this.detailForm.processes);

    },
    // 向上移动
    moveUp(index) {
      this.moveItem(index, 'up');
    },
    // 向下移动
    moveDown(index) {
      this.moveItem(index, 'down');
    },
    // 提取公共的移动逻辑
    moveItem(index, direction) {
      // 1. 获取当前激活的制成
      const activeProcess = this.detailForm.processes[this.activeProcessTab];
      if (!activeProcess) return;

      // 2. 通过activeFactorId精确定位当前操作的指标（关键修改）
      const activeIndicator = activeProcess.factors.find(
        factor => factor.tplFactorId === this.activeFactorId
      );
      if (!activeIndicator) return;

      // 3. 判断边界条件
      const dataLength = activeIndicator.sortData.length;
      if (direction === 'up' && index === 0) return; // 上移到顶
      if (direction === 'down' && index === dataLength - 1) return; // 下移到底

      // 4. 计算新索引并移动元素
      const newIndex = direction === 'up' ? index - 1 : index + 1;
      const [movedItem] = activeIndicator.sortData.splice(index, 1);
      activeIndicator.sortData.splice(newIndex, 0, movedItem);

      // 5. 同步更新排序信息
      this.syncParamSortOrder(activeIndicator);
      activeIndicator.sortData.forEach((item, i) => {
        item.sortIndex = i + 1;
      });

      // 6. 刷新表格
      this.refreshKey += 1;
    },
    onView(process, indicator) {
      // this.multiData = []
      this.previewMultiLists = []
      this.previewColumns = []
      this.detailForm.processes.forEach(ele => {
        if (ele.processCode == process.processCode) {
          if (!ele.factors || ele.factors.length == 0) {
            return
          }
          ele.factors.forEach(item => {
            if (item.factorCode == indicator.factorCode) {
              if (item.paramsLists && item.paramsLists.length > 0) {
                item.paramsLists.forEach(param => {
                  this.previewMultiLists.push({
                    paramCode: param.paramCode,
                    paramName: param.paramName,
                    paramDesc: param.paramDesc,
                  })
                })
              }
              this.previewColumns = [...item.columns]
            }
          })
        }
      })
      this.multiTitle = indicator.factorName ? indicator.factorName + ' - 单值二维列表维度预览' : '单值二维列表维度预览';
      this.multiValuesDialogVisible = true
    },
    onCloseMultiValuesDialog() {
      this.previewMultiLists = []
      this.previewColumns = []
      this.multiTitle = ''
      this.multiValuesDialogVisible = false
    },
    // 配置excel模板
    onConfigSheet() {
      this.sheetData = this.processData()
      console.log("🚀 ~ onConfigSheet ~ sheetData:", this.sheetData)
      this.sheetDialogVisible = true
    },
    processData(obj) {
      // 提取需要的数据
      const result = [];
      // 检查是否存在processes数组
      if (this.detailForm.processes && Array.isArray(this.detailForm.processes)) {
        this.detailForm.processes.forEach(process => {
          // 检查当前process是否存在factors数组
          if (process.factors && Array.isArray(process.factors)) {
            process.factors.forEach(factor => {
              // 提取所需字段
              result.push({
                processCode: process.processCode || "",
                processName: process.processName || "",
                factorCode: factor.factorCode || "",
                factorName: factor.factorName || "",
                sheetName: factor.sheetName || "",
                sheetIndex: factor.sheetIndex !== undefined ? factor.sheetIndex : ""
              });
            });
          }
        });
      }
      // 按照要求排序
      result.sort((a, b) => {
        // 先按sheetName排序
        if (a.sheetName < b.sheetName) return -1;
        if (a.sheetName > b.sheetName) return 1;
        // 如果sheetName相同，按processCode排序
        if (a.processCode < b.processCode) return -1;
        if (a.processCode > b.processCode) return 1;
        // 如果processCode相同，按factorCode排序
        if (a.factorCode < b.factorCode) return -1;
        if (a.factorCode > b.factorCode) return 1;
        return 0;
      });
      return result;
    },
    // 配置excel排序
    setSheetSort(data) {
      data.forEach(item => {
        // 遍历所有工序
        this.detailForm.processes.forEach(process => {
          // 匹配工序编码
          if (process.processCode === item.processCode) {
            // 遍历该工序下的所有指标
            process.factors.forEach(factor => {
              // 匹配指标编码
              if (factor.factorCode === item.factorCode) {
                // 回写数据
                factor.sheetName = item.sheetName
                factor.sheetIndex = item.sheetIndex
              }
            })
          }
        })
      })
      this.onCloseSheetDialog()
    },
    onCloseSheetDialog() {
      this.sheetData = []
      this.sheetDialogVisible = false
    },
    deleteProcess(dataList, index) {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        dataList.splice(index, 1);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteProcessParam(data, row, index) {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        data["paramsLists"].splice(index, 1);
        let sortIndex = data["sortData"].findIndex(data => data.code === row.paramCode && data.name === row.paramName);
        data["sortData"].splice(sortIndex, 1);
        data["sortData"].forEach((data, i) => {
          data.sortIndex = i + 1;
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 保存模板
    onSave() {
      this.apiFunc('DRAFT')
    },
    // 提交模板
    onSubmit() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          if (!this.detailForm.processes || this.detailForm.processes.length == 0) {
            this.$message.error('请至少添加一个制成')
            return
          }
          this.apiFunc('ACTIVE')
        }
      })
    },
    apiFunc(type) {
      if (this.detailForm.processes && this.detailForm.processes.length > 0) {
        this.detailForm.processes.forEach(process => {
          if (process.factors && process.factors.length > 0) {
            process.factors.forEach(factor => {
              factor.params = []
              factor.params = factor.params.concat(factor.statisticsParams).concat(factor.paramsLists)
              // 根据sortData的排序重新给params排序
              if(factor.params && factor.params.length > 0) {
                let sortData = factor.sortData?factor.sortData:[];
                factor.params.forEach(param => {
                  let filterObj = sortData.find(data => data.code === param.paramCode && data.name === param.paramName);
                  if(filterObj) {
                    param.sortIndex = filterObj.sortIndex;
                  }
                })
                factor.params = factor.params.sort((a, b) => a.sortIndex - b.sortIndex);
              }
            })
          }
        })
      }
      var obj = { ...this.detailForm }
      obj.createStatus = type
      if (obj.processes && obj.processes.length > 0) {
        obj.processes.forEach(process => {
          if (process.factors && process.factors.length > 0) {
            process.factors.forEach(factor => {
              delete factor.statisticsParams
              delete factor.paramsLists
            })
          }
        })
      }
      console.log('最后保存参数', obj);
      processApi.saveDraftTemplate(obj).then((res) => {
        console.log("🚀 ~ apiFunc ~ res:", res)
        if (res.code == '200') {
          if (type == 'DRAFT') {
            this.$message.success('保存成功')
            this.getDetailInfo(res.data)
          } else {
            this.$router.go(-1)
            this.$message.success('提交成功')
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 设置控制维度
    onSetControl(process, indicator, row, index) {
      this.selectedParam = row;
      this.controlForm.dataList = row.processList?row.processList.map(item => item.processCode):[];
      this.controlDialogVisible = true;
    },
    // 设置规则容差
    onSetRangeValue(process, indicator, row, index) {
      this.selectedParam = row;
      this.rangeForm.tolerance = row.tolerance;
      this.rangeForm.toleranceType = row.toleranceType;
      this.rangeDialogVisible = true;
    },
    confirmControl() {
      let checkedProcessList = this.controlProcessList.filter(process =>
          this.controlForm.dataList.some(data => data === process.processCode)
      );
      this.$set(this.selectedParam, 'processList', checkedProcessList);
      this.controlDialogVisible = false;
    },
    confirmRangeValue() {
      this.$set(this.selectedParam, 'toleranceType', this.rangeForm.toleranceType);
      this.$set(this.selectedParam, 'tolerance', this.rangeForm.tolerance);
      this.rangeDialogVisible = false;
    },
    // 返回
    onCancel() {
      this.$router.go(-1)
    },
  }
}
</script>

<style>
</style>